import React from 'react';
import PropTypes from 'prop-types';

function HitAddedTag({addedTime}) {
    return (
        <span
            className="scratchpad-hit-added-tag label label-default"
        >
            {addedTime}
        </span>
    );
}

HitAddedTag.propTypes = {
    addedTime: PropTypes.string
};

export default HitAddedTag;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitThumbnails/HitAddedTag/HitAddedTag.js